import React from 'react';

export const Logo = () => {
  // We need to generate a new id for each instance of this component to avoid
  // id mismatches when multiple instances of this component are rendered
  const randomSeed = Math.random();
  const clipPathId = `logo-clip-path-${randomSeed}`;
  const linearGradientId = `logo-linear-gradient-${randomSeed}`;

  return (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M46.0009 0.463867C20.8481 0.463867 0.460938 20.8511 0.460938 46.0039C0.460938 71.1567 20.8481 91.5439 46.0009 91.5439C71.1537 91.5439 91.5409 71.1567 91.5409 46.0039C91.5409 20.8511 71.1537 0.463867 46.0009 0.463867ZM61.2545 10.5839C69.4149 14.1121 76.1217 20.3773 80.2157 28.2203C56.2957 26.9829 49.1887 23.5697 46.5805 10.5839C46.3827 9.59027 46.2079 8.54147 46.0561 7.43747C51.4519 7.44207 56.5901 8.56447 61.2545 10.5839ZM30.7473 10.5839C35.4117 8.56447 40.5545 7.44207 45.9503 7.43747C45.7985 8.54607 45.6237 9.59487 45.4259 10.5839C42.8131 23.5697 35.7107 26.9783 11.7907 28.2203C15.8755 20.3773 22.5869 14.1121 30.7473 10.5839ZM46.0009 49.5459C32.5413 49.5459 20.5583 55.8479 12.8257 65.6551C9.40334 59.8959 7.43454 53.1753 7.43454 46.0039C7.43454 39.6513 8.98014 33.6529 11.7125 28.3629C37.7853 29.7061 43.8941 33.6253 46.0009 49.5459C46.0009 49.5459 46.0009 49.5091 46.0009 49.4401C46.0009 49.5091 46.0009 49.5459 46.0009 49.5459C48.1077 33.6253 54.2165 29.7061 80.294 28.3629C83.0264 33.6529 84.572 39.6513 84.572 46.0039C84.572 53.1753 82.6031 59.8959 79.1761 65.6551C71.4436 55.8479 59.4605 49.5459 46.0009 49.5459Z"
          fill={`url(#${linearGradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={linearGradientId}
          x1="46.0005"
          y1="0.581859"
          x2="46.0005"
          y2="91.4173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8A73BF" />
          <stop offset="1" stopColor="#251D34" stopOpacity="0" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="92" height="92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoBig = () => {
  // We need to generate a new id for each instance of this component to avoid
  // id mismatches when multiple instances of this component are rendered
  const randomSeed = Math.random();
  const clipPathId = `logo-clip-path-${randomSeed}`;
  const linearGradientId = `logo-linear-gradient-${randomSeed}`;
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M80.0008 0.807617C36.2568 0.807617 0.800781 36.2636 0.800781 80.0076C0.800781 123.752 36.2568 159.208 80.0008 159.208C123.745 159.208 159.201 123.752 159.201 80.0076C159.201 36.2636 123.745 0.807617 80.0008 0.807617ZM106.529 18.4076C120.721 24.5436 132.385 35.4396 139.505 49.0796C97.9048 46.9276 85.5448 40.9916 81.0088 18.4076C80.6648 16.6796 80.3608 14.8556 80.0968 12.9356C89.4808 12.9436 98.4168 14.8956 106.529 18.4076ZM53.4728 18.4076C61.5848 14.8956 70.5288 12.9436 79.9128 12.9356C79.6488 14.8636 79.3448 16.6876 79.0008 18.4076C74.4568 40.9916 62.1048 46.9196 20.5048 49.0796C27.6088 35.4396 39.2808 24.5436 53.4728 18.4076ZM80.0008 86.1676C56.5928 86.1676 35.7528 97.1276 22.3048 114.184C16.3528 104.168 12.9288 92.4796 12.9288 80.0076C12.9288 68.9596 15.6168 58.5276 20.3688 49.3276C65.7128 51.6636 76.3368 58.4796 80.0008 86.1676C80.0008 86.1676 80.0008 86.1036 80.0008 85.9836C80.0008 86.1036 80.0008 86.1676 80.0008 86.1676C83.6648 58.4796 94.2888 51.6636 139.641 49.3276C144.393 58.5276 147.081 68.9596 147.081 80.0076C147.081 92.4796 143.657 104.168 137.697 114.184C124.249 97.1276 103.409 86.1676 80.0008 86.1676Z"
          fill={`url(#${linearGradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={linearGradientId}
          x1="80"
          y1="1.01282"
          x2="80"
          y2="158.988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8A73BF" />
          <stop offset="1" stopColor="#251D34" stopOpacity="0" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
